// extracted by mini-css-extract-plugin
var _1 = "bEhU1";
var _2 = "hDH_4";
var _3 = "qUt9p";
var _4 = "FWmpb";
var _5 = "vH4E9";
var _6 = "QQrG_";
var _7 = "Ds7Qq";
export { _1 as "base", _2 as "info", _3 as "label", _4 as "permissionsCheckboxes", _5 as "permissionsLabel", _6 as "permissionsSection", _7 as "token" }
